"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchingChunk = matchingChunk;

/**
 * @module ol/geom/flat/straightchunk
 */

/**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */
function matchingChunk(maxAngle, flatCoordinates, offset, end, stride) {
  var chunkStart = offset;
  var chunkEnd = offset;
  var chunkM = 0;
  var m = 0;
  var start = offset;
  var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;

  for (i = offset; i < end; i += stride) {
    var x2 = flatCoordinates[i];
    var y2 = flatCoordinates[i + 1];

    if (x1 !== undefined) {
      x23 = x2 - x1;
      y23 = y2 - y1;
      m23 = Math.sqrt(x23 * x23 + y23 * y23);

      if (x12 !== undefined) {
        m += m12;
        acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));

        if (acos > maxAngle) {
          if (m > chunkM) {
            chunkM = m;
            chunkStart = start;
            chunkEnd = i;
          }

          m = 0;
          start = i - stride;
        }
      }

      m12 = m23;
      x12 = x23;
      y12 = y23;
    }

    x1 = x2;
    y1 = y2;
  }

  m += m23;
  return m > chunkM ? [start, i] : [chunkStart, chunkEnd];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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